import VConsole from 'vconsole';
const vConsole = () => {
    if (process.env.NODE_ENV !== 'production') {
        new VConsole({ theme: 'dark' });
    }
};

export default vConsole;
